// import logo from './logo.svg';
// import './App.css';

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./components/dashboard/AdminDashboard";
import UserDashboard from "./components/dashboard/UserDashboard";
import DeviceDetailsPage from "./pages/DeviceDetailsPage";
import DashboardLayout from "./components/dashboard/DashboardLayout";
import LiveMonitorPage from "./pages/LiveMonitorPage";
import EquipmentPage from "./pages/EquipmentPage";
import UserManagement from "./components/users/UserManagement";
import ViewHistoryPage from "./pages/ViewHistoryPage";
import RoleGuard from "./components/auth/RoleGuard";
import PublicRoute from "./components/auth/PublicRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route 
          path="/"
          element={
            <PublicRoute>  
              <LoginPage />
            </PublicRoute>  
          }
        />

        <Route
          path="/admin"
          element={
            <RoleGuard allowedRoles={["A"]}>
              <DashboardLayout role="A" />
            </RoleGuard>
          }
        >
          <Route 
            index
            element={<LiveMonitorPage />}
          />

          <Route 
            path="equipment"
            element={<EquipmentPage />}
          />

          <Route 
            path="users"
            element={<UserManagement />}
          />

          <Route 
            path="live/:deviceId"
            element={<DeviceDetailsPage />}
          />

          <Route
            path="live/:deviceId/history"
            element={<ViewHistoryPage />}
          />
        </Route>

        <Route
          path="/user"
          element={
            <RoleGuard allowedRoles={["U"]}>
              <DashboardLayout role="U" />
            </RoleGuard>
          }
        >
          <Route 
            index
            element={<LiveMonitorPage />}
          />

          <Route 
            path="live/:deviceId"
            element={<DeviceDetailsPage />}
          />

          <Route 
            path="live/:deviceId/history"
            element={<ViewHistoryPage />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
